// extracted by mini-css-extract-plugin
export var disableScroll = "disableScroll-module--disableScroll--nOeID";